import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function PaymentsFinTechLicenseSeychelles() {

    return (
        <main className='main'>
            <IntroSection
                title="Payments & FinTech License – Seychelles"
                subtitle="Launch PSPs, Remittance Firms & Digital Wallets in a Global Offshore Hub"
                description="Seychelles offers a competitive licensing framework for Payment Service Providers (PSPs), Money Service Businesses (MSBs), and fintech platforms. Under FSA regulation, licensed firms can handle money transfers, remittances, currency exchange, merchant payments, and digital wallets. Many PSPs also integrate crypto-to-fiat solutions, making Seychelles a fintech-friendly jurisdiction."
                badges={[
                    "PSPs",
                    "Remittance",
                    "E-Wallets",
                    "Hybrid FinTech & Crypto"
                ]}
                buttonText="Request a Seychelles Payments Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/payments-fintech-license-seychelles-hero.png")}
                imageAlt="Seychelles Payments & FinTech"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Seychelles for Payments & FinTech?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "FSA-Regulated",
                                                text: "Credible regulatory framework for PSPs & MSBs."
                                            },
                                            {
                                                title: "Lower Entry Barriers",
                                                text: "Cheaper and faster than EU EMI licenses."
                                            },
                                            {
                                                title: "Crypto-Friendly",
                                                text: "PSPs can integrate digital asset payment services."
                                            },
                                            {
                                                title: "Strategic Hub",
                                                text: "Serves Africa, Asia, and global e-commerce markets."
                                            },
                                            {
                                                title: "Tax Neutrality",
                                                text: "Foreign-sourced payment income is exempt."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Licenses in Seychelles"
                        blocks={[
                            {
                                title: "Payment Service Provider (PSP) License",
                                items: [
                                    { text: "Authorizes merchant payment processing, e-commerce acquiring, and e-wallets." },
                                    { text: "Supports multi-currency settlements and cross-border transactions." }
                                ]
                            },
                            {
                                title: "Money Services Business (MSB) License",
                                items: [
                                    { text: "Covers remittances, money transfers, and currency exchange." },
                                    { text: "Popular for Africa/Asia diaspora payment solutions." }
                                ]
                            },
                            {
                                title: "FinTech Platforms",
                                items: [
                                    { text: "Stored value, prepaid cards, and digital wallet ecosystems." },
                                    { text: "May include PSP + crypto gateway hybrid models." }
                                ]
                            },
                            {
                                title: "Hybrid FinTech & Crypto Gateways",
                                items: [
                                    { text: "Combines traditional payments with crypto on/off ramps." },
                                    { text: "Operates under PSP/MSB license with FSA notification." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Minimum Capital",
                                    text: "USD 50,000–100,000 depending on license scope."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Seychelles company required."
                                },
                                {
                                    title: "Resident Officers",
                                    text: "Resident director and compliance officer mandatory."
                                },
                                {
                                    title: "Local Office Presence",
                                    text: "Registered agent and compliance infrastructure required."
                                },
                                {
                                    title: "AML/KYC Policies",
                                    text: "Must follow FATF-aligned standards."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Seychelles Payments License'
                        services={
                            [
                                {
                                    title: "Respected Offshore PSP Hub",
                                    text: "Trusted by PSPs and remittance providers globally."
                                },
                                {
                                    title: "Faster Setup",
                                    text: "3–6 months vs 9–12 months in EU jurisdictions."
                                },
                                {
                                    title: "Crypto Integration",
                                    text: "PSPs can integrate crypto gateways for hybrid solutions."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Better access than unlicensed offshore fintech companies."
                                },
                                {
                                    title: "Cost-Effective",
                                    text: "Affordable setup and ongoing compliance."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Define PSP, MSB, or broader fintech model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register a Seychelles IBC or local entity."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Prepare business plan, AML/KYC policies, and financial projections."
                                },
                                {
                                    title: "FSA Review",
                                    text: "Regulator evaluates ownership, governance, and compliance readiness."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically issued within 3–6 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–6 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "From USD 40,000+ (legal, compliance, advisory)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 50k–100k",
                            },
                            {
                                name: "Annual Costs",
                                description: "Audits, regulator fees, compliance reporting",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in PSP and fintech licensing" },
                                { text: "End-to-end support: incorporation, license filing, compliance setup" },
                                { text: "Partnerships with banks, card issuers, and PSP providers" },
                                { text: "Guidance for hybrid PSP and crypto models" },
                                { text: "Comparative analysis: Seychelles vs St Lucia vs Panama vs Cyprus" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a PSP, remittance firm, or fintech startup?"
                        description="Seychelles offers flexible payment licenses under FSA, with low barriers and tax neutrality."
                        buttonText="Book a Seychelles Payments Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the capital requirement for a PSP license in Seychelles?",
        content: [
            { type: "answer", text: "USD 50k–100k depending on services." },
        ],
    },
    {
        question: "Can I combine crypto with a PSP?",
        content: [
            { type: "answer", text: "Yes — via hybrid PSP/crypto gateway models." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "3–6 months." },
        ],
    },
    {
        question: "Is Seychelles competitive vs EU EMI licenses?",
        content: [
            { type: "answer", text: "Yes — cheaper and faster, but less recognized globally." },
        ],
    },
    {
        question: "What’s the difference between PSP and MSB?",
        content: [
            { type: "answer", text: "PSPs handle e-commerce & merchant acquiring, MSBs cover remittances/currency exchange." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We licensed our PSP in Seychelles. Offshore Advisory managed FSA filings and introduced us to card partners.",
        author: "Kevin D.",
        role: "FinTech Founder"
    },
    {
        quote: "Seychelles was perfect for our remittance startup serving Africa. Offshore Advisory handled licensing and compliance.",
        author: "Maria L.",
        role: "MSB Entrepreneur"
    }
];
